var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-balance-manage',{staticClass:"pt-balance-manage__page"})}
var staticRenderFns = []

export { render, staticRenderFns }